import type { IntlShape } from 'react-intl';

/**
 * Localize a record field name. Entity-scoped fields live under an entity
 * namespace (`find.field.findSlipNumber`, …) while project/parcel fields live
 * under the generic `field.*`. Probe `intl.messages` so a missing key falls
 * back silently to the generic namespace — and finally to the raw field name.
 *
 * `prefix` is the label namespace, which is NOT always the entity name (the
 * `findingPlanum`/`findingProfile` entities label under `planum`/`profile`).
 */
export function resolveFieldLabel(
    intl: IntlShape,
    prefix: string,
    field: string
): string {
    const scopedId = `${prefix}.field.${field}`;
    if (intl.messages[scopedId]) {
        return intl.formatMessage({ id: scopedId });
    }
    const genericId = `field.${field}`;
    if (intl.messages[genericId]) {
        return intl.formatMessage({ id: genericId });
    }
    return field;
}
